import React, { memo } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { FilterRouter } from 'components/FilterView';
import { DataCatalog } from 'containers/Jit/DataCatalog/Loadable';
import { DataGroups } from 'containers/Jit/DataGroups/Loadable';
import { JitRequests } from 'containers/Jit/JitRequests/Loadable';
import { MaskingPolicies } from 'containers/Jit/MaskingPolicies/Loadable';
import { useInjector } from 'utils/inject';

import { jitSaga } from './saga';
import { Setup } from './Setup';
import { reducer, sliceKey } from './slice';

export const Jit = memo(() => {
  useInjector(sliceKey, reducer, jitSaga);

  return (
    <Routes>
      <Route element={<FilterRouter path="/jit/setup" />}>
        <Route path="setup/*" element={<Setup />} />
      </Route>
      <Route element={<FilterRouter path="/jit/data" />}>
        <Route path="data/catalog/*" element={<DataCatalog />} />
        <Route path="data/policy/*" element={<MaskingPolicies />} />
        <Route path="data/group/*" element={<DataGroups />} />
      </Route>
      <Route element={<FilterRouter path="/jit/requests" />}>
        <Route path="requests/*" element={<JitRequests />} />
      </Route>
      <Route index element={<Navigate to="data/catalog" replace />} />
    </Routes>
  );
});
